import { useState } from "react";
import { useNavigate } from "react-router-dom";
import './DashboardIterazioni.css';

const DashboardIterazioni = () => {
    const [iterazioni, setIterazioni] = useState([
        {
            id: 1,
            dataInserimento: '2024/06/12',
            dataEvasione: null,
            deadLine: '2024/09/12',
            dataPresaInCarico: '2024/06/15',
            descrizione: 'Realizzazione modulo di autenticazione OAuth & JWT',
            progettoId: 7,
            nomeProgetto: 'HailmanagementRevo',
            projectManager: 'Andrea',
            sviluppatore: 'Alessio',
            compagnia: 'Revo Insurance',
            feedBack: null,
            inProgress: true,
            inAttesaDiuFeedBack: false,
        },
        {
            id: 2,
            dataInserimento: '2024/05/10',
            dataEvasione: '2024/06/01',
            deadLine: '2024/06/05',
            dataPresaInCarico: '2024/05/12',
            descrizione: 'Integrazione gateway di pagamento Stripe',
            progettoId: 3,
            nomeProgetto: 'Agritek Core',
            projectManager: 'Marco',
            sviluppatore: 'Alessio',
            compagnia: 'Agritek',
            feedBack: 'Collaudato con successo',
            inProgress: false,
            inAttesaDiuFeedBack: false,
        },
        {
            id: 3,
            dataInserimento: '2024/06/20',
            dataEvasione: null,
            deadLine: '2024/09/30',
            dataPresaInCarico: '2024/06/22',
            descrizione: 'Restyling dashboard KPI & export PDF dei report',
            progettoId: 12,
            nomeProgetto: 'Myara Portal',
            projectManager: 'Elena',
            sviluppatore: 'Alessio',
            compagnia: 'Myara',
            feedBack: null,
            inProgress: false,
            inAttesaDiuFeedBack: true,
            feedbackNotes: ''
        }
    ]);

    const navigate = useNavigate();

    const navigateTo = (path) => {
        navigate(path);
    };

    const addIterazione = () => {
        const iterazioneCopy = [...iterazioni];
        const newId = iterazioneCopy.length > 0 ? Math.max(...iterazioneCopy.map(i => i.id)) + 1 : 1;
        const today = new Date().toISOString().slice(0, 10);
        const newIterazione = {
            id: newId,
            dataInserimento: today,
            dataEvasione: null,
            deadLine: '2024/12/31',
            dataPresaInCarico: today,
            descrizione: 'Nuova iterazione task...',
            progettoId: newId,
            nomeProgetto: 'Nuovo Progetto',
            projectManager: 'Andrea',
            sviluppatore: 'Alessio',
            compagnia: 'Cliente',
            feedBack: null,
            inProgress: true,
            inAttesaDiuFeedBack: false,
            createdBy: localStorage.getItem('email'),
            user: localStorage.getItem('email')
        };
        iterazioneCopy.unshift(newIterazione);
        setIterazioni(iterazioneCopy);
    };

    const iterazioneOk = (id) => {
        const copy = [...iterazioni];
        const item = copy.find(i => i.id === id);
        if (item) {
            item.dataEvasione = new Date().toISOString().slice(0, 10);
            item.inProgress = false;
            item.inAttesaDiuFeedBack = false;
            item.feedBack = item.feedbackNotes || 'Approvato dal cliente';
            setIterazioni(copy);
        }
    };

    const updateFeedbackNotes = (id, text) => {
        const copy = [...iterazioni];
        const item = copy.find(i => i.id === id);
        if (item) {
            item.feedbackNotes = text;
            setIterazioni(copy);
        }
    };

    const evaseTasks = iterazioni.filter(el => el.dataEvasione !== null);
    const inProgressTasks = iterazioni.filter(el => el.inProgress && el.dataEvasione === null);
    const waitingFeedbackTasks = iterazioni.filter(el => el.inAttesaDiuFeedBack && el.dataEvasione === null);

    return (
        <div className="kanban-page">
            <div className="page-header">
                <div className="header-title">
                    <h1>Kanban Board Iterazioni</h1>
                    <span className="count-badge">{iterazioni.length} Task Totali</span>
                </div>

                <div className="progetti-cont-btn">
                    <button onClick={addIterazione} className='btn-action primary'>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                        Nuova Iterazione
                    </button>
                    
                    <button onClick={() => navigateTo('/iterazioni')} className='btn-action secondary'>
                        Elenco Clienti
                    </button>
                </div>
            </div>

            <div className="kanban-board">
                {/* Column 1: In Progress */}
                <div className="kanban-column column-progress">
                    <div className="column-header">
                        <div className="header-left">
                            <span className="status-indicator blue"></span>
                            <h3>In Lavorazione</h3>
                        </div>
                        <span className="column-count">{inProgressTasks.length}</span>
                    </div>

                    <div className="kanban-cards-wrapper">
                        {inProgressTasks.map(el => (
                            <div key={el.id} className="kanban-card">
                                <div className="card-top">
                                    <span className="project-tag">{el.nomeProgetto}</span>
                                    <span className="compagnia-badge">{el.compagnia}</span>
                                </div>
                                <h4 className="card-title">#{el.id} - {el.descrizione}</h4>
                                
                                <div className="card-details-grid">
                                    <div><strong>Inserimento:</strong> {el.dataInserimento}</div>
                                    <div><strong>Deadline:</strong> {el.deadLine}</div>
                                    <div><strong>Dev:</strong> {el.sviluppatore}</div>
                                    <div><strong>PM:</strong> {el.projectManager}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Column 2: In Attesa di Feedback */}
                <div className="kanban-column column-waiting">
                    <div className="column-header">
                        <div className="header-left">
                            <span className="status-indicator orange"></span>
                            <h3>Attesa Feedback</h3>
                        </div>
                        <span className="column-count">{waitingFeedbackTasks.length}</span>
                    </div>

                    <div className="kanban-cards-wrapper">
                        {waitingFeedbackTasks.map(el => (
                            <div key={el.id} className="kanban-card warning-border">
                                <div className="card-top">
                                    <span className="project-tag">{el.nomeProgetto}</span>
                                    <span className="compagnia-badge">{el.compagnia}</span>
                                </div>
                                <h4 className="card-title">#{el.id} - {el.descrizione}</h4>

                                <div className="card-details-grid">
                                    <div><strong>Inserimento:</strong> {el.dataInserimento}</div>
                                    <div><strong>Deadline:</strong> {el.deadLine}</div>
                                    <div><strong>Dev:</strong> {el.sviluppatore}</div>
                                    <div><strong>PM:</strong> {el.projectManager}</div>
                                </div>

                                <div className="feedback-form">
                                    <label>Modifiche o Note Cliente:</label>
                                    <textarea 
                                        placeholder="Inserisci note o riscontro cliente..." 
                                        value={el.feedbackNotes || ''}
                                        onChange={(e) => updateFeedbackNotes(el.id, e.target.value)}
                                    />
                                    <button className="btn-approve" onClick={() => iterazioneOk(el.id)}>
                                        ✓ Segna come Evasa
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Column 3: Completate / Evase */}
                <div className="kanban-column column-done">
                    <div className="column-header">
                        <div className="header-left">
                            <span className="status-indicator green"></span>
                            <h3>Evase & Completate</h3>
                        </div>
                        <span className="column-count">{evaseTasks.length}</span>
                    </div>

                    <div className="kanban-cards-wrapper">
                        {evaseTasks.map(el => (
                            <div key={el.id} className="kanban-card success-border">
                                <div className="card-top">
                                    <span className="project-tag">{el.nomeProgetto}</span>
                                    <span className="compagnia-badge">{el.compagnia}</span>
                                </div>
                                <h4 className="card-title">#{el.id} - {el.descrizione}</h4>

                                <div className="card-details-grid">
                                    <div><strong>Evasione:</strong> <span className="evasione-date">{el.dataEvasione}</span></div>
                                    <div><strong>Dev:</strong> {el.sviluppatore}</div>
                                    <div><strong>PM:</strong> {el.projectManager}</div>
                                </div>

                                {el.feedBack && (
                                    <div className="feedback-box">
                                        <strong>Feedback:</strong> {el.feedBack}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardIterazioni;